import React from "react";
import styled from "styled-components";
import Modal from "components/Artists/Modal";
import Close from "assets/close.svg";

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  preview: string;
}

export const PreviewModal: React.FC<PreviewModalProps> = props => {
  const { isOpen, onClose, preview } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose} width="500px">
      <ModalBody >
        <CloseButton onClick={onClose}>
          <Close/>
        </CloseButton>
        {preview && <img src={preview} alt="preview" width="500px" />}
      </ModalBody>
    </Modal>
  );
};

export const ModalBody = styled.div`
  position: relative;
  background: #292D32E5;
`
export const CloseButton = styled.div`
    position: absolute;
    z-index: 999;
    right: -18px;
    top: -18px;
    cursor: pointer;
`;
